/******************************************************
 *                  Module Common
 ********************************************************/

"use strict";

angular.module("app", [
	"services",
	"admin",
	"carto-iti",
	"coherence",
	"data-management",
	"exploitation",
	"manager",
	"open-iti",

	"angular-img-cropper",
	//"camera",
	"chart.js",
	"checklist-model",
	"config",
	"datatables",
	"datatables.bootstrap",
	"datatables.columnfilter",
	"datatables.colvis",
	"mhicauber.tch-selectable-row", // select a row in a table adds css class
	"ngAnimate",
	"ngProgress", // top screen progress bar
	"ngRoute", // to configure routing
	"ngSanitize",
	"ngStorage",
	"toastr", // toast notifications
	"toggle-switch",
	"ui.bootstrap",
	"ui-leaflet",
	"ui.select"
]);
